'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // import get from 'lodash/get';


var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _pick = require('lodash/pick');

var _pick2 = _interopRequireDefault(_pick);

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

var _defaultsDeep = require('lodash/defaultsDeep');

var _defaultsDeep2 = _interopRequireDefault(_defaultsDeep);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _asyncRetry = require('async-retry');

var _asyncRetry2 = _interopRequireDefault(_asyncRetry);

var _camelCase = require('./utils/camelCase');

var _camelCase2 = _interopRequireDefault(_camelCase);

var _ApiError = require('./errors/ApiError');

var _ApiError2 = _interopRequireDefault(_ApiError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var axiosParams = ['method', 'url', 'data', 'auth'];

// TODO: once consensus is reached with platform on how to handle certain status codes, we'll then
// uncomment logic here to retry on those codes. For now, we'll just retry on timeout.
// const retryOnResponseStatusRegex = /^50(0|[2-4])$|^408$/;

module.exports = function tuneInRequest(requestConfig, apiContext) {
  if ((0, _isEmpty2.default)(requestConfig.url)) {
    throw new Error('api endpoint must be configured and defined.');
  }

  var startTime = Date.now();
  var axiosRequest = (0, _pick2.default)(requestConfig, axiosParams);

  function responseHandler(res) {
    var responseTime = Date.now() - startTime;

    var responseParams = {
      responseTime: responseTime,
      status: res ? res.status : null
    };

    var configParams = (0, _pick2.default)(axiosRequest, ['url', 'method']);

    // Just track the names of the cookies sent
    if (apiContext.logCookieNames && axiosRequest.headers.cookie) {
      var cookieNames = axiosRequest.headers.cookie.split('; ') // split cookies first
      .map(function (cookie) {
        return cookie.includes('=') && cookie.split('=')[0];
      }) // then by key value
      .filter(function (val) {
        return val;
      }) // filter out falsey values
      .join(','); // join as string delimited

      configParams.cookieNames = cookieNames;
    }

    var trackingData = (0, _merge2.default)({}, responseParams, configParams);
    apiContext.track(trackingData);
  }

  axiosRequest.withCredentials = true;
  if (!requestConfig.withoutParams) {
    axiosRequest.params = (0, _defaultsDeep2.default)(requestConfig.params, apiContext.params);
  }
  axiosRequest.headers = (0, _defaultsDeep2.default)(requestConfig.headers, apiContext.headers);
  axiosRequest.transformResponse = [].concat(_axios2.default.defaults.transformResponse);
  axiosRequest.timeout = apiContext.timeout;
  axiosRequest.httpsAgent = apiContext.apiHttpsAgent;

  if (!requestConfig.disableCamelCase) {
    axiosRequest.transformResponse.push(_camelCase2.default);
  }

  if (requestConfig.transformResponse) {
    axiosRequest.transformResponse.push(requestConfig.transformResponse);
  }

  if (requestConfig.isAjax) {
    axiosRequest.headers['X-Requested-With'] = 'XMLHttpRequest';
  }

  if (requestConfig.noAuthHeader) {
    delete axiosRequest.headers.Authorization;
  }

  var requestCallback = function requestCallback(bail, reqAttempt) {
    return (0, _axios2.default)(_extends({}, axiosRequest, {
      params: _extends({}, axiosRequest.params, {
        reqAttempt: reqAttempt
      })
    })).then(function (res) {
      responseHandler(res);
      return res;
    }).catch(function (err) {
      responseHandler(err.response);
      throw err;
    }).catch(function (err) {
      var errorToUse = _axios2.default.isAxiosError(err) ? new _ApiError2.default(err) : err;

      // We should only retry for:
      // 1) Timeouts that stem from our timeout config, which is presented as an axios
      //    `ECONNABORTED` error.
      // 3) TODO: Possible axios error responses that are 408, 500, or 502-504, signifying that
      //    the server may possibly recover before another retry.
      // Otherwise, we bail!
      if (err.code !== 'ECONNABORTED' // &&
      // !retryOnResponseStatusRegex.test(get(err, 'response.status'))
      ) {
          return bail(errorToUse);
        }

      throw errorToUse;
    });
  };

  return (0, _asyncRetry2.default)(requestCallback, { retries: !requestConfig.disableRetry && apiContext.retryLimit });
};
//# sourceMappingURL=tuneInRequest.js.map